import { connect } from 'react-redux';
import NavBar from 'components/NavBar';

const mapStateToProps = ({ machine, language }) => ({
  machine: machine,
  availableLanguages: language.availableLanguages,
});

export default connect(mapStateToProps, null)(NavBar);
